import styles from "./LabelRequired.module.css"

function LabelRequired({children}) {
    return (
        <label className={styles.labelRequired}>
            {children}
            <span> *</span>
        </label>
    )
}

export default LabelRequired;